import { gql } from "@apollo/client";

export default gql`
  mutation DispatchRepeatAtomicEmail($input: DispatchRepeatAtomicEmailArgs!) {
    dispatchRepeatAtomicEmail(input: $input) {
      message
    }
  }
`;
